function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, _ref) {
  let [min, max] = _ref;
  return Math.min(max, Math.max(min, value));
}
export { $ae6933e535247d3d$export$7d15b64cf5a3a4c4 as clamp };